import axios from 'axios';
import {
  AdminCountriesApiFactory,
  AdminMaterialsApiFactory,
  AdminProductVariantsApiFactory,
  AdminProductsApiFactory,
  AdminReportsApiFactory,
  AdminSalesChannelsApiFactory,
  CategoriesApiFactory,
  Configuration,
  SalesChannelItemsApiFactory,
} from '@cdaas/api-clients/dist/product-service-openapi';

const productServiceConfig = new Configuration({
  basePath: process.env.REACT_APP_PRODUCT_SERVICE_URL,
});

export const productServiceAdminSalesChannelsClient = AdminSalesChannelsApiFactory(productServiceConfig, undefined, axios);
export const productServiceSalesChannelItemsClient = SalesChannelItemsApiFactory(productServiceConfig, undefined, axios);
export const productServiceCategoriesClient = CategoriesApiFactory(productServiceConfig, undefined, axios);
export const productServiceCountriesClient = AdminCountriesApiFactory(productServiceConfig, undefined, axios);
export const productServiceMaterialsClient = AdminMaterialsApiFactory(productServiceConfig, undefined, axios);
export const productServiceVariantsClient = AdminProductVariantsApiFactory(productServiceConfig, undefined, axios);
export const productServiceProductClient = AdminProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceReportsClient = AdminReportsApiFactory(productServiceConfig, undefined, axios);
